import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DestroyModal from 'components/application/DestroyModal';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function BookingDestroyModal({
  autoEnrolmentExclusion,
  booking,
  course,
  isOpen,
  onClose,
  onDestroy,
  personnel,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.BookingDestroyModal',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const courseHasELearningCourse = !!course?.relationships.eLearningCourse.data;

  const isAutoEnrollingCourse =
    courseHasELearningCourse &&
    currentActor.isAllowedFeature([
      'e_learning_auto_enrol',
      'e_learning',
      'training_register',
    ]) &&
    !!course?.relationships?.autoEnrolmentConfiguration?.data;

  return (
    <DestroyModal
      additionalContent={
        <div className='tw-rounded-l tw-m-0 tw-mt-5 tw-border-0'>
          <p>
            {courseHasELearningCourse ?
              i18nT('additionalContent.eLearning')
            : i18nTCommon(
                'personnel.emailNotifications.personnelAndLineManager',
              )
            }
          </p>
          {isAutoEnrollingCourse && !autoEnrolmentExclusion && (
            <p>
              {i18nT('additionalContent.autoEnrol', {
                interpolation: { escapeValue: false },
                name: personDisplayName({ attributes: personnel }),
              })}
            </p>
          )}
        </div>
      }
      confirmationText={i18nTCommon('bookings.removeBooking')}
      displayText={i18nTCommon(
        courseHasELearningCourse ?
          'bookings.areYouSureYouWantToRemoveEnrolmentForCourse'
        : 'bookings.areYouSureYouWantToRemoveBookingForCourse',
        {
          courseName: course?.attributes.name,
          interpolation: { escapeValue: false },
        },
      )}
      isOpen={isOpen}
      onClose={onClose}
      onDestroy={() => onDestroy({ bookingId: booking?.id, isNotified: true })}
    />
  );
}

BookingDestroyModal.propTypes = {
  personnel: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  booking: resourceShape('booking'),
  course: resourceShape('course'),
  autoEnrolmentExclusion: resourceShape('autoEnrolmentExclusion'),
  onDestroy: PropTypes.func.isRequired,
};
